import { z } from 'zod';
import { Signup } from './signup';
import { SignupData } from './signup.data';

export const SignupEmailRequestSchema = z.object({
    email: z.string().email().toLowerCase().trim(),
});

export type SignupEmailRequest = z.infer<typeof SignupEmailRequestSchema>;

export type SignupEmailResponse = {
    success: boolean;
    message?: string;
    form?: Partial<Signup>;
    data?: SignupData;
    nextStep?: 'verify' | 'form' | 'complete';
}